export function getWebUrl(website: string) {
  if (!website) {
    return '';
  }
  if (website.startsWith('http:') || website.startsWith('https:')) {
    return website;
  }
  return `http://${website}`;
}
